module.exports = __webpack_public_path__ + "static/img/code1.3494d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zyy/code1.png
// module id = +2Rj
// module chunks = 9